import { render } from "./WhyHpDigital.vue?vue&type=template&id=272b3c40&scoped=true"
import script from "./WhyHpDigital.vue?vue&type=script&lang=js"
export * from "./WhyHpDigital.vue?vue&type=script&lang=js"

import "./WhyHpDigital.vue?vue&type=style&index=0&id=272b3c40&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-272b3c40"]])

export default __exports__